import * as React from 'react';

export const grFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_424)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_424'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_424)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H5.33333V5.33333H0V0ZM8 0H13.3333V5.33333H8V0ZM0 8H5.33333V13.3333H0V8ZM8 8H13.3333V13.3333H8V8ZM13.3333 0H28V2.66667H13.3333V0ZM13.3333 5.33333H28V8H13.3333V5.33333Z'
                    fill='#055EB0'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 10.6667H28V13.3333H0V10.6667ZM5.33333 10.6667H8V13.3333H5.33333V10.6667ZM0 16H28V18.6667H0V16Z'
                    fill='#055EB0'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_424'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
